import { useEffect } from "react";
import useApiBase from "./api/useApiBase";

const DEFAULT_TITLE = "Line Control";

let faviconResolved = false;
let cachedFaviconPath = null;
let siteMetaPromise = null;

function resolveFaviconHref(path) {
  if (!path) {
    return null;
  }
  const text = String(path).trim();
  if (!text) {
    return null;
  }
  if (/^https?:\/\//i.test(text) || text.startsWith("data:")) {
    return text;
  }
  const publicUrl = process.env.PUBLIC_URL || "";
  if (text.startsWith("/")) {
    return `${publicUrl}${text}`;
  }
  return `${publicUrl}/${text}`;
}

function applyFavicon(href) {
  if (!href || typeof document === "undefined") {
    return;
  }
  let link = document.querySelector("link[rel='icon']");
  if (!link) {
    link = document.createElement("link");
    link.setAttribute("rel", "icon");
    document.head.appendChild(link);
  }
  if (link.getAttribute("href") !== href) {
    link.setAttribute("href", href);
  }
}

function fetchSiteMeta(apiBase) {
  if (faviconResolved) {
    return Promise.resolve({ faviconPath: cachedFaviconPath });
  }
  if (!siteMetaPromise) {
    siteMetaPromise = fetch(`${apiBase}/api/health`, { credentials: "include" })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        faviconResolved = true;
        cachedFaviconPath = resolveFaviconHref(data?.favicon_path);
        if (cachedFaviconPath) {
          applyFavicon(cachedFaviconPath);
        }
        return { faviconPath: cachedFaviconPath };
      })
      .catch(() => {
        siteMetaPromise = null;
        return { faviconPath: null };
      });
  }
  return siteMetaPromise;
}

function usePageTitle(title) {
  const apiBase = useApiBase();

  useEffect(() => {
    let active = true;
    fetchSiteMeta(apiBase).then((meta) => {
      if (active && meta?.faviconPath) {
        applyFavicon(meta.faviconPath);
      }
    });
    return () => {
      active = false;
    };
  }, [apiBase]);

  useEffect(() => {
    const previous = document.title;
    document.title = title || DEFAULT_TITLE;
    return () => {
      document.title = previous;
    };
  }, [title]);
}

export default usePageTitle;
